import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AvForm } from 'availity-reactstrap-validation';
import {
  AddButton,
  Buttons,
  CancelButton,
  DeleteButton,
  UpdateButton,
} from '../../../components/Common/iComponents/iPopUp/IpopUp';

import { IInput } from '../../../components/Common/iComponents/iInput/iInput';
import { ISwitch } from '../../../components/Common/iComponents/iSwitch/iSwitch';
import { Label, FormGroup } from 'reactstrap';

const FormRoles = ({
  selectedRow,
  onCreateRoles,
  onUpdateRoles,
  onDeleteRoles,
  onCancel,
}: any) => {
  const arrayUpdAdd = [
    'nombre',
    'version',
    'descripcion',
    'MCA_ACTIVO',
    'MCA_SUPERUSUARIO',
  ];
  const columsPop = 2;
  const [form, setForm] = useState({
    nombre: '',
    version: '',
    descripcion: '',
    MCA_ACTIVO: false,
    MCA_SUPERUSUARIO: false,
  });
  const [flag, setflag] = useState<any>(true);
  useEffect(() => {
    if (selectedRow) {
      setForm(selectedRow);
    }
  }, [selectedRow]);

  const itemVals = (val: any, updateVal: any) => {
    for (const property in updateVal) {
      if (property === val) {
        return updateVal[property];
      }
    }
  };
  const renderButtons = () => (
    <Buttons>
      {selectedRow ? (
        <>
          <CancelButton
            className="button"
            onClick={() => onCancel()}
            data-bs-toggle="tooltip"
          >
            <i
              className="bx bx-power-off"
              style={{ fontSize: '2.5em' }}
              data-bs-toggle="tooltip"
            ></i>
          </CancelButton>
          <DeleteButton
            className="btn-delete"
            onClick={() => onDeleteRoles(selectedRow.id)}
          >
            <i className="dripicons-trash" style={{ fontSize: '1.7em' }}></i>
          </DeleteButton>
          <UpdateButton
            className="button"
            disabled={flag}
            onClick={() => onUpdateRoles(form)}
          >
            <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
          </UpdateButton>
        </>
      ) : (
        <AddButton
          type="submit"
          disabled={flag}
          className="btn"
          onClick={() => {
            onCreateRoles(form);
          }}
        >
          <i className="bx bx-user-check" style={{ fontSize: '3.5em' }} />
        </AddButton>
      )}
    </Buttons>
  );

  useEffect(() => {
    const { nombre, version } = form;
    if (nombre != '' && version != '') {
      setflag(false);
    } else {
      setflag(true);
    }
  }, [form]);

  const onChangeHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: e.target.value,
    });
  };

  const onChangeBooleanHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: !form[n as keyof typeof form],
    });
  };

  return (
    <>
      <div style={{ width: '650px', height: '450px' }}>
        <AvForm
          className="custom-form mt-0"
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
            gridAutoRows: 'minmax(10%, 90px)',
            gridGap: '2%',
            padding: '0',
            marginLeft: '5%',
            marginRight: '5%',
          }}
        >
          {arrayUpdAdd?.map((val: any) => {
            const firstLet = val[0].toUpperCase();
            const rest = val.slice(1);
            const word = firstLet + rest;
            const nameObject = val as keyof typeof form;
            const temp = form[nameObject];
            const valid = temp ? true : false;
            const type = '';
            const value = selectedRow ? itemVals(val, selectedRow) : null;
            return (
              <div style={{ marginTop: '15%', color: 'black' }}>
                {val === 'MCA_ACTIVO' || val === 'MCA_SUPERUSUARIO' ? (
                  <FormGroup className="text-center">
                    <div className="text-capitalize">
                      <Label>{val.replace(/_/g, ' ').toLowerCase()}</Label>
                    </div>
                    <Label>
                      <ISwitch
                        title={val}
                        checked={Boolean(form[nameObject])}
                        onChangeBooleanHandler={onChangeBooleanHandler}
                      />
                    </Label>
                  </FormGroup>
                ) : (
                  <IInput
                    title={val}
                    valid={valid}
                    value={value}
                    type={type}
                    onChangeHandler={onChangeHandler}
                  />
                )}
              </div>
            );
          })}
        </AvForm>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '1%',
          marginRight: '1%',
        }}
      >
        {renderButtons()}
      </div>
    </>
  );
};

FormRoles.propTypes = {
  selectedRow: PropTypes.object,
  onCreateRoles: PropTypes.func,
  onUpdateRoles: PropTypes.func,
  onDeleteRoles: PropTypes.func,
  onCancel: PropTypes.func,
};

export default FormRoles;
